"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.html = void 0;
const util_1 = require("../util");
const HtmlParser_1 = require("./HtmlParser");
const parsers_1 = require("./parsers");
exports.html = new HtmlParser_1.HtmlParser({ parsers: (0, parsers_1.parsers)(util_1.dhe) });
